<template>
  <div class="container">
    <div class="con_wrap button">
      <div class="con_title">
        <img class="con_title_icon" src="../../../assets/images/evaluate/success.png" >
        <div class="con_title_t">
          已评价！
        </div>
      </div>
      <div class="con_tips">感谢您的认可,我们会努力做的更好</div>
      <div class="con_btn btn_default" v-if="showBack" @click="back">返回</div>
    </div>
  </div>
</template>

<script>

export default {
  name:"success",
  data(){
    return {
      showBack:true
    }
  },
  methods: {
    back(){
      // window.history.back(-1);
      this.$router.go(-1)
    }
  },
  created(){
    if(this.$route.query.come == 'smEvaluate'){
      this.showBack = false
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.con_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.con_title{
  margin-bottom: 28px;
  margin-top: 200px;
  height:66px;
  display: flex;
  align-items: center;
  .con_title_icon{
    width: 44px;
    height: 44px;
    margin:12px 14px 10px;
  }
  .con_title_t{
    font-size:48px;
    font-family:PingFangSC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:66px;

  }
}
.con_tips{
  height:40px;
  font-size:28px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
  margin-bottom: 120px;
  text-align: center;
}
.con_btn{
  width:332px;
  height:76px;
  background:rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  line-height: 76px;
  font-size:32px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(255,255,255,1);
}
</style>
